export class Phone {
    Number?: string;
    Extension?: string;
}
